const SET_ZOOM_LEVEL = (state, value) => {
  state.zoomLevel = value
}

const SET_LOCALE = (state, value) => {
  state.locale = value
}

const SET_DICT_LANG = (state, value) => {
  state.dictLang = value.code
  state.dictName = value.name
}

const SET_PAGES_PER_VIEW = (state, value) => {
  state.pagesPerView = value
}

const SET_LIBRARY_FILTER = (state, value) => {
  state.libraryFilter = value
}

const SET_LIBRARY_FILTER_OFFLINE = (state, value) => {
  state.libraryFilterOffline = value
}

const SET_LIBRARY_LOADED = (state, value) => {
  state.libraryLoaded = value
}

const SET_LIBRARY_SCROLL_POS = (state, value) => {
  state.libraryScrollPos = value
}

const SET_LAST_READ_PAGE = (state, value) => {
  state.lastReadPage = value
}

const CLEAR_SETTINGS = (state) => {
  state.zoomLevel = 100
  state.pagesPerView = 2
}

const SET_CONNECTION = (state, value) => {
  state.connection = value
}

const SET_BUBBLE_ACCEPTANCE = (state, value) => {
  state.bubbleAccepted = value
}

const SET_RESPONSIVE = (state, value) => {
  state.responsive = value
}

export default {
  SET_ZOOM_LEVEL,
  SET_LOCALE,
  SET_DICT_LANG,
  SET_PAGES_PER_VIEW,
  SET_LAST_READ_PAGE,
  CLEAR_SETTINGS,
  SET_CONNECTION,
  SET_BUBBLE_ACCEPTANCE,
  SET_LIBRARY_FILTER,
  SET_LIBRARY_LOADED,
  SET_LIBRARY_SCROLL_POS,
  SET_LIBRARY_FILTER_OFFLINE,
  SET_RESPONSIVE
}
